const collapsibleHandler = (event) => {
  event.target.nextElementSibling.classList.toggle(
    'collapsible__indicator--asc',
  );
  event.target.nextElementSibling.classList.toggle(
    'collapsible__indicator--desc',
  );
  const collapsibleContent = event.target.parentElement.nextElementSibling;
  if (collapsibleContent) {
    collapsibleContent.classList.toggle('collapsible__content--active');
    collapsibleContent.classList.toggle('collapsible__content--inactive');
    if (
      collapsibleContent.style.maxHeight
      || collapsibleContent.classList.contains('collapsible__content--inactive')
    ) {
      collapsibleContent.style.maxHeight = null;
    } else {
      collapsibleContent.style.maxHeight = `${collapsibleContent.scrollHeight}px`;
    }
  }
};

const collapsibleElement = (collapsibleElements) => {
  collapsibleElements.forEach((collapsible) => {
    collapsible.addEventListener('click', collapsibleHandler);
  });
};

const collapsiblesDisconnect = (collapsibleElements) => {
  collapsibleElements.forEach((collapsible) => {
    collapsible.removeEventListener('click', collapsibleHandler);
  });
};

export default () => {
  const collapsibleElements = document.querySelectorAll('.collapsible');
  collapsibleElement(collapsibleElements);

  return () => {
    collapsiblesDisconnect(collapsibleElements);
  };
};
